export default ({ children, value }) => (!!value ? children : null);
